module.exports = "/_next/static/images/icon-apply-live-0b9ae933.png";